module.exports = __webpack_public_path__ + "img/discord.b020dc0c.svg";